import 'twin.macro'

import OtpVerify from 'components/views/otp-verify'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { useActivationVerifyMutation } from '../redux/api/mega-card-activation.api'
import { mobilePhoneSelector } from '../redux/store/slices/mega-card-activation-slice'

function OtpVerifyPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [verifyActivation, { isLoading }] = useActivationVerifyMutation()
  const phoneNumber = useSelector(mobilePhoneSelector)

  const {
    control,
    formState: { errors, isValid },
    watch,
    setError
  } = useForm({ defaultValues: { code: '' } })

  const otp = watch('code')

  const handleVerify = async () => {
    try {
      if (phoneNumber) await verifyActivation({ code: otp, mobile_phone: phoneNumber }).unwrap()
      navigate('/idn-enter')
    } catch (error) {
      const typedError = error as {
        data: {
          error: { description: string; code: string }
        }
      }
      setError('code', { type: 'otp', message: typedError.data.error.description })
    }
  }

  return (
    <div tw='relative z-10 bg-secondary sm:min-w-[370px] max-w-[440px] w-full mx-auto rounded-s20 p-8 flex flex-col gap-4 justify-center mt-5 sm:mt-0'>
      <p tw='text-s18 font-medium'>{t('modal_title', { ns: 'otp' })}</p>
      {phoneNumber && (
        <OtpVerify
          phone={phoneNumber}
          control={control}
          name='code'
          isOtpValid={!isValid}
          isLoading={isLoading}
          onOtpVerify={handleVerify}
          errorMsg={errors.code?.message}
        />
      )}
    </div>
  )
}

export default OtpVerifyPage
